"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_1 = require("@tencent/spaui");
var DefaultActionComponent = function DefaultActionComponent(props) {
  var index = props.index,
    hottag = props.hottag,
    onDelete = props.onDelete,
    className = props.className,
    _a = props.buttonProps,
    buttonProps = _a === void 0 ? {} : _a;
  return react_1["default"].createElement("div", {
    className: "odc-twins-action"
  }, react_1["default"].createElement(spaui_1.Button, __assign({
    className: (0, classnames_1["default"])('odc-twins-minibtn', className),
    "data-hottag": "".concat(hottag, ".delete"),
    onClick: onDelete,
    "aria-label": "\u79FB\u9664",
    "data-index": index,
    useBaseClass: false,
    icon: react_1["default"].createElement(spaui_1.Icon, {
      name: 'minus-bold-outlined'
    })
  }, buttonProps)));
};
exports["default"] = DefaultActionComponent;